import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = () => ({
    previousPage: ''
})

const mutations = {
    SET_PREVIOUS_PAGE(state, value) {
        state.previousPage = value;
    }
}

export default {
    namespaced: true,
    state,
    mutations
}

